export default {
  namespaced: true,
  state: {
    uid: '',
    email: '',
    emailVerified: false,
    idProviders: []
  },
  mutations: {
    onAuthStateChanged(state, payload) {
      state.uid = payload.uid;
      state.email = payload.email;
      state.idProviders = payload.providerData?.map(p => p.providerId);
      state.emailVerified = payload.emailVerified;
    }
  },
  actions: {
    initStore({ commit }, payload) {
      commit('onAuthStateChanged', payload);
    },
    signOut({ commit }) {
      commit('onAuthStateChanged', { uid: '', email: '' });
    }
  },
  getters: {
    // user's identity is authenticated by firebase
    isAuthenticated(state) {
      return state.uid.length != 0;
    }
  }
};
